import React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/Users/jarl/Documents/Projects/civitas/kenobi/docs/node_modules/gatsby-theme-docz/src/base/Layout.js";
import { Playground, Props } from 'docz';
import styled from 'styled-components';
import { Button, Input } from 'kenobi-ui';
import PurpleButton from '../components/PurpleButton';
import Row from '../components/Row';
import Component from '@reach/component-component';
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <h1 {...{
      "id": "button"
    }}>{`Button`}</h1>
    <h3 {...{
      "id": "button-is-a-base-component-of-kenobi-it-can-contain-a-label-and-an-icon-before-or-after-the-label"
    }}><inlineCode parentName="h3">{`Button`}</inlineCode>{` is a base component of Kenobi. It can contain a label and an icon before or after the label.`}</h3>
    <h2 {...{
      "id": "usage"
    }}>{`Usage`}</h2>
    <Playground __position={0} __code={'<Button>Base button</Button>'} __scope={{
      props,
      DefaultLayout,
      Playground,
      Props,
      styled,
      Button,
      Input,
      PurpleButton,
      Row,
      Component
    }} mdxType="Playground">
  <Button mdxType="Button">Base button</Button>
    </Playground>
    <h2 {...{
      "id": "variations"
    }}>{`Variations`}</h2>
    <p><strong parentName="p">{`Component and Row are not a part of Kenobi`}</strong></p>
    <Playground __position={1} __code={'<Component initialState={{ isLoading: false }}>\n  {({ state, setState }) => (\n    <React.Fragment>\n      <div style={{ marginBottom: \'12px\' }}>\n        <Button\n          onClick={() => setState({ isLoading: !state.isLoading })}\n          marginBottom={4}\n        >\n          {state.isLoading ? \'Hide\' : \'Show\'} loading state\n        </Button>\n      </div>\n      <Row>\n        <Button marginRight={8} isLoading={state.isLoading}>\n          Default\n        </Button>\n        <Button intent=\"primary\" marginRight={8} isLoading={state.isLoading}>\n          Primary\n        </Button>\n        <Button intent=\"success\" marginRight={8} isLoading={state.isLoading}>\n          Success\n        </Button>\n        <Button intent=\"warning\" marginRight={8} isLoading={state.isLoading}>\n          Warning\n        </Button>\n        <Button intent=\"danger\" marginRight={8} isLoading={state.isLoading}>\n          Danger\n        </Button>\n        <Button marginRight={8} iconBefore=\"edit\" isLoading={state.isLoading}>\n          Icon before\n        </Button>\n        <Button marginRight={8} iconAfter=\"edit\" isLoading={state.isLoading}>\n          Icon after\n        </Button>\n      </Row>\n    </React.Fragment>\n  )}\n</Component>'} __scope={{
      props,
      DefaultLayout,
      Playground,
      Props,
      styled,
      Button,
      Input,
      PurpleButton,
      Row,
      Component
    }} mdxType="Playground">
  <Component initialState={{
        isLoading: false
      }} mdxType="Component">
    {({
          state,
          setState
        }) => <React.Fragment>
        <div style={{
            marginBottom: '12px'
          }}>
          <Button onClick={() => setState({
              isLoading: !state.isLoading
            })} marginBottom={4} mdxType="Button">
            {state.isLoading ? 'Hide' : 'Show'} loading state
          </Button>
        </div>
        <Row mdxType="Row">
          <Button marginRight={8} isLoading={state.isLoading} mdxType="Button">
            Default
          </Button>
          <Button intent="primary" marginRight={8} isLoading={state.isLoading} mdxType="Button">
            Primary
          </Button>
          <Button intent="success" marginRight={8} isLoading={state.isLoading} mdxType="Button">
            Success
          </Button>
          <Button intent="warning" marginRight={8} isLoading={state.isLoading} mdxType="Button">
            Warning
          </Button>
          <Button intent="danger" marginRight={8} isLoading={state.isLoading} mdxType="Button">
            Danger
          </Button>
          <Button marginRight={8} iconBefore="edit" isLoading={state.isLoading} mdxType="Button">
            Icon before
          </Button>
          <Button marginRight={8} iconAfter="edit" isLoading={state.isLoading} mdxType="Button">
            Icon after
          </Button>
        </Row>
      </React.Fragment>}
  </Component>
    </Playground>
    <p><a parentName="p" {...{
        "href": "/icon"
      }}>{`More information on usage of Icons`}</a></p>
    <h2 {...{
      "id": "sizing"
    }}>{`Sizing`}</h2>
    <p>{`Default size for buttons are 32px.
`}<inlineCode parentName="p">{`Button`}</inlineCode>{` will handle its own scaling based on the height.`}</p>
    <Playground __position={2} __code={'<Row>\n  <Button height={24} marginRight={8}>\n    Height 24\n  </Button>\n  <Button height={32} marginRight={8}>\n    Height 32\n  </Button>\n  <Button height={40} marginRight={8}>\n    Height 40\n  </Button>\n  <Button height={48} marginRight={8}>\n    Height 48\n  </Button>\n  <Button height={56} marginRight={8}>\n    Height 56\n  </Button>\n</Row>'} __scope={{
      props,
      DefaultLayout,
      Playground,
      Props,
      styled,
      Button,
      Input,
      PurpleButton,
      Row,
      Component
    }} mdxType="Playground">
  <Row mdxType="Row">
    <Button height={24} marginRight={8} mdxType="Button">
      Height 24
    </Button>
    <Button height={32} marginRight={8} mdxType="Button">
      Height 32
    </Button>
    <Button height={40} marginRight={8} mdxType="Button">
      Height 40
    </Button>
    <Button height={48} marginRight={8} mdxType="Button">
      Height 48
    </Button>
    <Button height={56} marginRight={8} mdxType="Button">
      Height 56
    </Button>
  </Row>
    </Playground>
    <h2 {...{
      "id": "usage-as-a-link"
    }}>{`Usage as a link`}</h2>
    <p>{`Due to using Styled-components as our CSS-in-JS library it is really simple to switch out the underlying
HTML element. We just have to pass the prop `}<strong parentName="p">{`isLink`}</strong>{` to the Button component.
The button will pass the `}<strong parentName="p">{`as`}</strong>{` prop to the Styled element.`}</p>
    <p>{`This will render the button as an `}<strong parentName="p">{`anchor`}</strong>{` element.`}</p>
    <Playground __position={3} __code={'<Button isLink={true} href=\"/button#button-as-a-link\">\n  I am a link!\n</Button>'} __scope={{
      props,
      DefaultLayout,
      Playground,
      Props,
      styled,
      Button,
      Input,
      PurpleButton,
      Row,
      Component
    }} mdxType="Playground">
  <Button isLink={true} href="/button#button-as-a-link" mdxType="Button">
    I am a link!
  </Button>
    </Playground>
    <h2 {...{
      "id": "extending-styles"
    }}>{`Extending styles`}</h2>
    <p>{`It's very easy to extend Button styles with styled-components. (Haven't tested any other solutions).`}</p>
    <PurpleButton mdxType="PurpleButton">I am now Purple!</PurpleButton>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`import styled from 'styled-components';
import { Button } from 'kenobi-ui';

const PurpleButton = styled(Button)\`
  background-color: #551a8b;
\`;

<PurpleButton>I am now Purple!</PurpleButton>;
`}</code></pre>
    <h2 {...{
      "id": "props"
    }}>{`Props`}</h2>
    <Props of={Button} mdxType="Props" />

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      